<template>
  <div class="page-container">
    <span class="parent-path">帳號管理 / </span><span class="current-path">新增帳號</span>
    <span class="page-title">新增帳號</span>
    <div class="card-content">
      <form @submit.prevent="handleSubmit" class="account-form">

        <div class="section">
          <h2>基本資訊</h2>
          <div class="form-grid">
            <a-form-item :validateStatus="errors.last_name ? 'error' : ''" :help="errors.last_name">
              <a-label for="lastName">姓氏</a-label>
              <a-input v-model:value="form.last_name" id="lastName" type="text"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.first_name ? 'error' : ''" :help="errors.first_name">
              <a-label for="firstName">名字</a-label>
              <a-input v-model:value="form.first_name" id="firstName" type="text"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.email ? 'error' : ''" :help="errors.email">
              <a-label for="email">電子信箱</a-label>
              <a-input v-model:value="form.email" id="email" type="text"/>
            </a-form-item>
            <a-form-item>
              <a-label for="company">公司</a-label>
              <a-input :value="company?.name" id="company" type="text" disabled/>
            </a-form-item>
            <a-form-item :validateStatus="errors.password ? 'error' : ''" :help="errors.password">
              <a-label for="password">密碼</a-label>
              <a-input v-model:value="form.password" id="password" type="text"/>
            </a-form-item>
            <!--            <div class="form-group">-->
            <!--              <a-label for="role">權限</a-label>-->
            <!--              <a-input v-model="form.role" id="role" type="text"/>-->
            <!--            </div>-->
          </div>
        </div>

        <div class="form-actions">
          <a-button type="button" class="btn-cancel" @click="handleCancel">取消</a-button>
          <a-button html-type="submit" class="btn-submit">新增</a-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {message} from "ant-design-vue";

export default {
  inject: ['getSelectedCompany'],
  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        role: ""
      },
      errors: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        role: ""
      }
    };
  },
  computed: {
    company() {
      return this.getSelectedCompany();
    }
  },
  methods: {
    handleSubmit() {
      console.log("表單提交", this.form);

      for (let key in this.errors) {
        this.errors[key] = ""
      }

      const token = localStorage.getItem('token');
      this.$axios.post('/api/users', {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        password: this.form.password,
        email: this.form.email,
        organization_id: this.company.id
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        console.log(response)
        message.success("已完成帳號新增，並寄送密碼至電子信箱")
        this.$router.go(-1)
      }).catch(error => {
        console.error(error);
        if (error.status === 401) {
          this.$router.push('/login');
        } else {
          console.log(error.response.data);
          let errors = error.response.data
          for (let key in errors) {
            this.errors[key] = errors[key]['message']
          }
        }
      });
    },
    handleCancel() {
      this.$router.go(-1)
    },
  },
};
</script>

<style scoped>
.card-content {
  background-color: white;
  border-radius: 8px;
  width: 1024px;
  padding: 20px;
  margin-top: 16px;
}

.section {
  margin-bottom: 2em;
}

.section h2 {
  font-size: 1.2em;
  margin-bottom: 1em;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1em;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  font-size: 0.9em;
  margin-bottom: 0.5em;
  color: #333;
}

input {
  padding: 0.7em;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 4px;
}

input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1em;
}

.btn-cancel {
  background-color: #f8f9fa;
  color: #333;
}

.btn-submit {
  background-color: #007bff;
  color: white;
}

.btn-submit:hover {
  background-color: #0056b3;
}
</style>
